
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.692 9.722c7.009 0 12.69 5.721 12.69 12.778s-5.681 12.778-12.69 12.778C5.682 35.278 0 29.558 0 22.5 0 15.443 5.682 9.722 12.692 9.722zm20.267.748c3.505 0 6.346 5.386 6.346 12.03 0 6.643-2.84 12.03-6.345 12.03s-6.346-5.387-6.346-12.03 2.84-12.03 6.345-12.03zm9.81 1.253C44 11.723 45 16.548 45 22.5c0 5.95-1 10.777-2.232 10.777-1.233 0-2.231-4.825-2.231-10.777 0-5.951.999-10.777 2.231-10.777z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    